export default __webpack_public_path__ + "static/media/pendo_badge_bone.e6fb2b8e.svg";